import React, { useState } from "react";
import CourseStoreStyle from "./style";
import { DownloadOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import card1Img from "../../../assets/Icons/card1Img.png";

const ViewCourse = ({ courseData, setCourseData }) => {
  const [courseVideoModal, setCourseVideoModal] = useState(false);
  return (
    <>
      <CourseStoreStyle>
        <div className="view_course_header_container">
          <div className="back_icon_section">
            <DownloadOutlined
              className="back_icon"
              onClick={() => setCourseData("")}
            />
          </div>
          <div className="view_course_header_contents">
            <div className="view_course_left_details">
              <span className="spancontent">{courseData.spanContent}</span>
              <p className="course_name">{courseData.CourseName}</p>
              <p className="course_code">{courseData.CourseCode}</p>
            </div>

            <div className="you_tube_player_container">
              <img src={card1Img} alt="course-image" className="" />

              <Button>Get this course</Button>
              <Button onClick={() => setCourseVideoModal(true)}>
                Intro Video
              </Button>
            </div>
          </div>
        </div>
        <div className="content_container">
          <p className="content_details_sentence">Lots of us have home assistants in our homes nowadays. They’re very clever. You can get recipes, play music, control your lights, and so much more with just a simple voice command. But home assistants are just 1 example of an amazing development in technology called artificial intelligence, or AI for short.
            <br></br>
            We’ve all heard that phrase, and most people could probably give a basic explanation, but who really knows exactly what it is? Thankfully, this course will give you the insight you need, by explaining exactly what AI is and how it can be useful day-to-day.
          </p>

          <p className="content_details_sentence">Lots of us have home assistants in our homes nowadays. They’re very clever. You can get recipes, play music, control your lights, and so much more with just a simple voice command. But home assistants are just 1 example of an amazing development in technology called artificial intelligence, or AI for short.
            <br></br>
            We’ve all heard that phrase, and most people could probably give a basic explanation, but who really knows exactly what it is? Thankfully, this course will give you the insight you need, by explaining exactly what AI is and how it can be useful day-to-day.
          </p>
        </div>
      </CourseStoreStyle>

      <Modal
        open={courseVideoModal}
        footer={false}
        onCancel={() => setCourseVideoModal(false)}
        width={800}
        closable={false}
      >
        <iframe
          width="100%"
          height="400px"
          src="https://www.youtube.com/embed/SqcY0GlETPk"
          title="Demo Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal>
    </>
  );
};

export default ViewCourse;
